import {
  configApiRef,
  createFrontendModule,
  featureFlagsApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';
import { RybbitAnalytics } from './RybbitAnalytics';

/**
 * Attaches to `api:app/analytics`, the app plugin extension that provides
 * `analyticsApiRef` and fans every event out to each implementation on it. So
 * this adds a destination rather than replacing the analytics API.
 */
const rybbitAnalytics = AnalyticsImplementationBlueprint.make({
  name: 'rybbit',
  params: define =>
    define({
      deps: {
        configApi: configApiRef,
        identityApi: identityApiRef,
        featureFlagsApi: featureFlagsApiRef,
      },
      factory: ({ configApi, identityApi, featureFlagsApi }) =>
        RybbitAnalytics.fromConfig(configApi, {
          identityApi,
          featureFlagsApi,
        }),
    }),
});

/**
 * Sends captured analytics events to Rybbit, configured under
 * `app.analytics.rybbit`. Inert until a config layer names a site.
 */
export const rybbitAnalyticsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [rybbitAnalytics],
});
